// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bF7AX","largestCol":"styles_largestCol__3mNfw","smallestCol":"styles_smallestCol__Ygxfh"};